<div class="single-filter-wrapper">
  <div class="pl-1 pr-1 pt-2 pb-2 border-bottom-lightest" *ngIf="searchFilter?.isSearchEnable">
    <app-input [placeholder]="searchFilter?.searchPlaceholder" [value]="query" styleClassInput="width-100p"
      theme="border" (appChange)="onSearch($event, searchFilter?.serachField || nameField || valueField)"
      [maxLength]="searchFilter?.maxLength || 1000">
    </app-input>
  </div>
  <div class="single-filter-body" [ngStyle]="{ 'max-height': scrollHeight }" (scroll)="onScroll($event)">
    <ng-container *ngIf="!searchFilter?.isSearchEnable">
      <!-- The disabled-pointers-event-none class will only be effective when applied to the parent element that handles interactions.
       Also please check shared.scss > line # 18520-->
      <div class="data-list-filter" *ngFor="let option of data; let i = index"
        [ngClass]="{'disabled-item disabled-pointers-event-none': option?.isInActive}">
        <div class="single-filter-wrapper" (click)="onOptionClick(option)">
          <div [class]="'check ' + name + ' '">
            <app-radio-button [name]="name" [selectedValue]="selectedValue? selectedValue[valueField] : ''"
              [value]="option[valueField]">
            </app-radio-button>
          </div>

          <div class="name">
            <div class="name-max width-100p" tooltipPosition="top" [pTooltip]="option.tooltip">
              {{option[nameField]}}
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="searchFilter?.isSearchEnable">
      <div class="data-list-filter" *ngFor="let option of listData; let i = index">
        <div class="single-filter-wrapper" (click)="onOptionClick(option)">
          <div class="check">
            <app-radio-button [name]="name" [selectedValue]="selectedValue? selectedValue[valueField] : ''"
              [value]="option[valueField]">
            </app-radio-button>
          </div>

          <div class="name">
            <div class="name-max width-100p">
              {{option[nameField]}}
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
